import React, { useState } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import PinCodeKeyPads from "./PinCodeKeyPads"
import classes from "./index.module.scss"

const array = [1, 2, 3, 4]

const KfPinCodeModal = (props) => {
  const {
    code,
    open,
    onClose,
    onSuccess = () => { },
    onFailed = () => { }
  } = props

  const [t] = useTranslation()

  const [pin, setPin] = useState("")
  const [showError, setShowError] = useState(false)

  if (!open) return null

  return (
    <div id="pin-modal" className={classes["container"]}>
      <div className={classes["header"]}>
        <div className={classes["title"]}>
          {t("پین_کد_را_وارد_کنین")}
        </div>
        <div className={classes["circules"]}>
          {array.map((_, i) =>
            <div
              key={i}
              className={clsx(
                classes["circule"],
                !!pin[i] && classes["active"]
              )}
            />
          )}
        </div>
        {
          showError &&
          <div className={classes["error"]}>
            {t("کد_درست_نیست")}
          </div>
        }
      </div>

      <PinCodeKeyPads
        code={code}
        pin={pin}
        setPin={setPin}
        onSuccess={onSuccess}
        onFailed={onFailed}
        setShowError={setShowError}
      />

      <div className={classes["footer"]}>
        <button
          className={classes["close"]}
          onClick={() => {
            onClose()

            setPin("")
          }}
        >
          <MdClose size={22} />
        </button>
      </div>
    </div>
  )
}

export default KfPinCodeModal